import { action, atom } from '@reatom/framework'

import { Async, AsyncStateN, pipe, Result } from '@blade/std-lib'
import { selectedNetworkAtom } from '@root/entities/network'
import { UnknownError, type Error } from '@root/shared'

import { walletsModelAtom } from './reatom-user-wallets'
import { fetchWalletsRequestAction } from './wallet-requests'

export const refreshWalletsReatom = ({
  minWaitingTime = 1000,
}: {
  minWaitingTime?: number
}) => {
  const refreshStateAtom = atom(
    AsyncStateN.notInitiated<Error.UnknownError, unknown>(),
    'refreshStateAtom',
  )

  const refreshWalletsAction = action(async (ctx) => {
    const network = ctx.get(selectedNetworkAtom)
    const state = ctx.get(refreshStateAtom)
    if (AsyncStateN.isLoading(state)) {
      return
    }

    refreshStateAtom(ctx, AsyncStateN.loading())

    const [result] = await ctx.schedule(() =>
      Promise.all([
        fetchWalletsRequestAction(ctx, network),
        Async.delay(minWaitingTime),
      ]),
    )

    const mappedResult = pipe(
      result,
      Result.mapError(UnknownError.fallbackToUnknown),
    )
    if (Result.isSuccess(mappedResult)) {
      const model = ctx.get(walletsModelAtom)
      model.update(ctx, mappedResult.success)
    }
    refreshStateAtom(ctx, AsyncStateN.fromResult(mappedResult))
  }, 'refreshWalletsAction')

  return {
    refreshStateAtom,
    refreshWalletsAction,
  }
}
